"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionHeadingRegistryWidget = exports.AccordionHeadingWidget = void 0;
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var AccordionContext_1 = require("./AccordionContext");
var withCentredAccordionButton_1 = __importDefault(require("ContentTokens/SharedWidgetComponents/Accordion/withCentredAccordionButton"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var PlaceholderContext_1 = __importDefault(require("Project/QwilrEditor/Placeholder/PlaceholderContext"));
var styles = __importStar(require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css"));
var styleUtilities_1 = require("ContentTokens/SharedWidgetComponents/Accordion/styleUtilities");
var dynamic_1 = require("@vanilla-extract/dynamic");
var accordion_css_1 = require("ContentTokens/SharedWidgetComponents/Accordion/accordion.css");
var pages_common_1 = require("@qwilr/pages-common");
var StylesContext_1 = require("Project/QwilrEditor/StylesContext");
var ACCORDION_HEADING_BASE_CLASS_NAME = "accordion-widget-heading";
exports.AccordionHeadingWidget = (0, withCentredAccordionButton_1.default)((0, AccordionContext_1.withAccordionContext)((0, mobx_react_1.observer)(function (_a) {
    var _b, _c, _d;
    var attributes = _a.attributes, children = _a.children, _e = _a.context, expanded = _e.expanded, setExpanded = _e.setExpanded, isVisualStyleAccordion = _e.isVisualStyleAccordion, backgroundImageUrl = _e.backgroundImageUrl, handleSwapImageClick = _e.handleSwapImageClick, handleVisualAccordionImageClick = _e.handleVisualAccordionImageClick, showControls = _e.showControls, style = _e.style, buttonTopMargin = _a.buttonTopMargin;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(ACCORDION_HEADING_BASE_CLASS_NAME, styles.accordionHeading({
            buttonPosition: (0, styleUtilities_1.calculateButtonPosition)(style),
            expanded: Boolean(expanded),
            type: isVisualStyleAccordion ? "visual" : style.headerBackground.on ? "simple" : "transparent",
        }), styles.accordionHeadingEditor({
            type: isVisualStyleAccordion ? "visual" : style.headerBackground.on ? "simple" : "transparent",
        })), style: __assign(__assign({}, attributes.style), (isVisualStyleAccordion && {
            backgroundImage: "url(".concat(backgroundImageUrl, ")"),
        })), onMouseDown: handleVisualAccordionImageClick }),
        isVisualStyleAccordion && (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: isVisualStyleAccordion && showControls, timeout: kaleidoscope_2.AnimationDuration.Medium, classNames: "".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__controls-"), mountOnEnter: true, unmountOnExit: true },
            react_1.default.createElement("div", { className: "".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__controls"), contentEditable: false },
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Image, null), tooltip: { content: "Swap image" }, type: kaleidoscope_1.ButtonType.Secondary, "aria-label": "swap image", onClick: handleSwapImageClick })))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button-wrapper"), styles.buttonWrapper({
                buttonType: style.buttonStyle,
                type: style.cardStyle,
            }), styles.buttonWrapperEditor), contentEditable: false, style: __assign({ marginTop: buttonTopMargin }, (0, dynamic_1.assignInlineVars)((_b = {},
                _b[accordion_css_1.computedVars.focusColor] = (0, styleUtilities_1.calculateFocusColor)(style),
                _b))) },
            react_1.default.createElement("button", { onMouseDown: function (e) {
                    e.nativeEvent.stopImmediatePropagation();
                }, onClick: function () { return setExpanded(!expanded); }, className: (0, classnames_1.default)("".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button"), "user-font", (_c = {},
                    _c["".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button--expanded")] = expanded,
                    _c["".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button--collapsed")] = !expanded,
                    _c), styles.headingButton({
                    buttonType: style.buttonStyle,
                    expanded: Boolean(expanded),
                })), style: __assign({}, (0, dynamic_1.assignInlineVars)((_d = {},
                    _d[accordion_css_1.computedVars.buttonCollapseIcon] = (0, styleUtilities_1.getAccordionCollapsedButtonIcon)(style),
                    _d[accordion_css_1.computedVars.buttonExpandIcon] = (0, styleUtilities_1.getAccordionExpandedButtonIcon)(style),
                    _d[accordion_css_1.computedVars.textLabelIconBackground] = (0, styleUtilities_1.getTextLabelIconBackground)(style),
                    _d[accordion_css_1.computedVars.buttonTextColor] = (0, styleUtilities_1.goldilocksButtonText)(style),
                    _d))) })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__content"), styles.headingContent({
                type: style.cardStyle,
            }), styles.headingContentEditor) },
            react_1.default.createElement(PlaceholderContext_1.default, { placeholders: {
                    heading1: "Add a heading",
                    heading2: "Add a heading",
                    heading3: "Add a heading",
                    heading4: "Add a heading",
                    paragraph: "Add a heading",
                    smallText: "Add a heading",
                    captionText: "Add a heading",
                } },
                react_1.default.createElement(StylesContext_1.LayoutStylesContextProvider, { backgroundColor: style.headerBackground.color.abs, computeForegroundColor: function (preferredForegroundColor) {
                        if (style.cardStyle === "visual") {
                            return "white";
                        }
                        if (!style.headerBackground.on) {
                            return preferredForegroundColor;
                        }
                        return (0, pages_common_1.goldilocks)(style.headerBackground.color.abs, {
                            mode: "text",
                            foregroundColor: preferredForegroundColor,
                        });
                    } }, children)))));
})));
var AccordionHeadingRegistryWidget = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(exports.AccordionHeadingWidget, { attributes: {}, isSelected: false }, children));
};
exports.AccordionHeadingRegistryWidget = AccordionHeadingRegistryWidget;
